import axios from 'axios'

/**
 * download
 * Provides a method to make the user download a file from an url in a sweet way
 */
export default {
  data () {
    return {
      isDownloadingFile: false,
    }
  },
  methods: {
    downloadFile (fileUrl, name, extension) {
      if (!fileUrl) return
      this.isDownloadingFile = true
      
      // Determine the file name and extension for the downloaded file
      const fileNameRegex = /([^\/]+)(?=\.\w+$|$)/ 
      const extensionRegex = /(?:\.([^.]+))?$/
      name = name || fileNameRegex.exec(fileUrl)[0]
      extension = extension || extensionRegex.exec(fileUrl)[1]
      
      // Determine how to download the file
      if (name && extension && fileUrl.includes('eo.nl') || !fileUrl.includes('http') && !navigator.userAgent.match('CriOS')) {
        // File can be downloaded automatically via blob
        axios({
          url: fileUrl,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          const hyperlink = document.createElement('a')
          const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
          hyperlink.href = blobUrl
          hyperlink.setAttribute('download', `${name}.${extension.replaceAll('.', '')}`)
          document.body.appendChild(hyperlink)
          hyperlink.click()
          document.body.removeChild(hyperlink)
          this.isDownloadingFile = false
        })
      } else {
        // File has to be downloaded manually via new tab
        const hyperlink = document.createElement('a')
        hyperlink.href = fileUrl
        hyperlink.setAttribute('target', `_blank`)
        document.body.appendChild(hyperlink)
        hyperlink.click()
        document.body.removeChild(hyperlink)
        this.isDownloadingFile = false
      }
    },
  },
}
 